<template>
  <div class="goods-wrap">
    <div
      v-for="(item, index) in goodsList"
      :key="index"
      class="goods-box"
      :style="{ width: goodsBoxWidth }"
      @click="$emit('click', { data: item, index })"
    >
      <div class="goods-image">
        <img class="image" :src="item.skuThumb" />
      </div>
      <div class="goods-info">
        <div v-if="formData.showLabel" class="goods-title">
          <span>{{ item.title || '商品名称' }}</span>
        </div>
        <div class="tags">
          <template v-if="item.actInfos">
            <template v-for="(act, actIndex) in item.actInfos">
              <span v-if="!act.__hiddenAct" :key="actIndex">
                {{ actMatchList[act.actType] }}
              </span>
            </template>
          </template>
        </div>
        <div v-if="formData.showPrice" class="goods-price">
          <span v-if="item.__actPrice" class="real-price">
            <span class="unit-icon">¥</span>
            <span>{{ item.__actPrice.toFixed(2) }}</span>
          </span>
          <span v-if="!item.__actPrice" class="real-price">
            <span class="unit-icon">¥</span>
            <span>{{ item.sellPrice.toFixed(2) }}</span>
          </span>
          <span v-if="item.marketPrice" class="original-price">
            <span class="unit-icon">¥</span>
            <span>{{ item.marketPrice.toFixed(2) }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { actMatchList, handlerActGoodsPrice } from '../../../common'

export default {
  name: 'index',
  components: {},
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        list: [],
        showPrice: true,
        showLabel: true
      },
      goodsList: [],
      actMatchList: actMatchList
    }
  },
  computed: {
    goodsBoxWidth() {
      const num = this.value.inlineNum || 1
      return 'calc(' + Math.floor(100 / num) + '% - 13px)'
    }
  },
  watch: {
    value: {
      handler(value) {
        if (!value.list || !value.list.length) {
          this.goodsList = []
          return
        }
        this.formData = value
        this.getGoods(value.list)
        console.log('111', value.list)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getGoods(goodsList) {
      if (!goodsList.length) return
      const skuIds = goodsList.map((item) => {
        return item.skuId
      })
      const params = {
        skuIds,
        fillTypes: ['fill_act', 'fill_shipping'],
        exposure: 'h5'
      }
      this.$service.getGoodsByIds(params).then((res) => {
        console.log('商品信息', res)
        const data = res.data
        const arr = handlerActGoodsPrice(data)
        const list = []
        skuIds.forEach((id) => {
          const match = arr.find((goods) => goods.skuId === id)
          if (match) {
            list.push(match)
          }
        })
        this.goodsList = list
      })
    }
  },
  created() {},
  mounted() {}
}
</script>

<style scoped lang="stylus">
.goods-wrap {
  display: flex;
  padding: 5px;
  box-sizing: border-box;
  width: 100%;
  min-height: 290px;
  flex-wrap: wrap;
  justify-content: space-between;
}

.goods-box {
  width: 100%;
  min-height: 250px;
  padding: 0 0 10px;
  box-sizing: border-box;
  box-shadow: 0 0 12px #d8d8d8;
  border-radius: 8px;
  margin: 5px;
  background: #fff;
  .goods-info {
    padding: 0 5px;
    .goods-title {
      font-size: 14px;
      padding: 4px 0;
      white-space: nowrap;
      overflow: hidden;
      box-sizing: border-box;
      text-overflow: ellipsis;
    }
  }

  .goods-image {
    background: #fff;
    width: 100%;
    height: 190px;
    border-radius: 5px;
    .image {
      object-fit: contain;
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
  }
}

.goods-price {
  .unit-icon {
    font-size: 0.8em;
  }
  .real-price {
    color: red;
    font-size: 18px;
  }
  .original-price {
    margin-left: 10px;
    color: #333;
    text-decoration: line-through;
    font-size: 14px;
  }
}

.tags {
  overflow: hidden;
  height: 28px;
  span {
    display: inline-block;
    background: rgba(252, 76, 0, 0.1);
    border: 1rpx solid #FC4C00;
    box-sizing: border-box;
    border-radius: 2px;
    margin: 3px;
    font-size: 10px;
    color: #FC4C00;
    padding: 2px 5px;
    max-width: 100px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
